<template>
    <div class="locale-changer">
        <v-select v-model="$i18n.locale" data-key="`Lang${i}`" data-value="lang" :items="langs" @change="changeLang"></v-select>
    </div>
</template>

<script>
    export default {
        name: 'locale-changer',
        data () {
            return {
                lang: this.$i18n.locale,
                langs: ['de', 'en']
            }
        },
        methods: {
            changeLang: function() {
                this.$vuetify.lang.current = this.$i18n.locale;
            }
        }
    }
</script>
